import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import DirtyModalAmexPayback from '@/components/promotion/DirtyModalAmexPayback.vue';
// eslint-disable-next-line
// @ts-ignore
import pinBlue from '~img/sites/region/pin-blue.svg';
import { HighlightType } from '~model';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopWallItem',
  props: {
  /* Name of the Shop like 'My Example Shop' */
  name: {
    type: String,
    default: null,
  },
  subHeadline: {
    type: String,
    default: null,
  },
  /* URL-Slug of shop like '/example-shop' */
  slug: {
    type: String,
    default: null,
  },
  /* ID of the Shop like '5' or '1189' */
  id: {
    type: Number,
    default: null,
  },
  /* Shop logo as image source-string (url) */
  logo: {
    type: String,
    default: null,
  },
  /* If enabled, the shop is highlighted as one of the bestseller or valentinesday shops */
  highlight: {
    type: [Boolean, String] as PropType<HighlightType>,
    default: false,
  },
  /* If enabled, the shop will be clickable for selection (on redeem / after valid voucher input) */
  interactive: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



const { getters } = store;
const voucher = computed(() => getters.getVoucher);
const configId = computed(() => getters.getConfigId);
const showShopNameOnShopWall = computed(() => getters.getShowShopNameOnShopWall);
const clickable = computed(() => props.interactive || configId.value === 'region');

const country = computed(() => getters.getCountry);
const voucherTokenPayload = computed(() => getters.getVoucherTokenPayload);

const showAmexPaybackModal = ref(false);
const modalKey = ref(0);

const category = computed(() => getters.getCategory);

const userHasAnswered = computed(() => getters.getIsPaybackCustomer !== null);

const dirtyModalAmexPaybackActive = computed((): boolean => {
  const hasCategory = !category.value;
  const showForSites = (
    sites: string[],
  ) => sites.includes(configId.value);
  const showForCountries = (
    countries: string[],
  ) => countries.includes(country.value?.toLocaleLowerCase());
  const noThirdPartyRedeem = !('thirdPartyRedeem' in voucherTokenPayload.value);
  const inDateRange = new Date('2024-06-05') <= new Date() && new Date('2026-05-01 23:59:59') >= new Date();

  return (
    hasCategory &&
    showForCountries(['de']) &&
    showForSites(['wunschgutschein-de']) &&
    noThirdPartyRedeem &&
    inDateRange
  );
});

function showDirtyModal(): void {
  modalKey.value += 1;
  showAmexPaybackModal.value = true;
}

const router = useRouter();
const route = computed(() => ({
  name: 'shopDetails',
  params: {
    id: props.id.toString(),
    slug: props.slug,
  },
}));

const href = computed(() => router.resolve(route.value).href);

function showShopDetailsModal(): void {
  showAmexPaybackModal.value = false;

  switch (true) {
    case props.interactive:
      router.push(route.value);
      break;

    case configId.value === 'region':
      store.state.region.shopModal = true;
      store.dispatch('fetchShopDetails', props.id);
      break;

    default:
      break;
  }
}

function handleClick(): void {
  if (dirtyModalAmexPaybackActive.value && !userHasAnswered.value) {
    showDirtyModal();
  } else {
    store.state.customer.form.redeemStartingPoint.source = 'partnerLogo';
    showShopDetailsModal();
  }
}

return { __sfc: true,props, getters, voucher, configId, showShopNameOnShopWall, clickable, country, voucherTokenPayload, showAmexPaybackModal, modalKey, category, userHasAnswered, dirtyModalAmexPaybackActive, showDirtyModal, router, route, href, showShopDetailsModal, handleClick, DirtyModalAmexPayback, pinBlue }
}

})